export default function vatCountryCode(countryCode: string): boolean {
  return window.ENV.vat.countryCodes.includes(countryCode);
}
